import { render, staticRenderFns } from "./homefooter.vue?vue&type=template&id=cc9ec44a&scoped=true&"
import script from "./homefooter.vue?vue&type=script&lang=js&"
export * from "./homefooter.vue?vue&type=script&lang=js&"
import style0 from "./homefooter.vue?vue&type=style&index=0&id=cc9ec44a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9ec44a",
  null
  
)

export default component.exports